<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text } from '@Shelly/shelly-design-system';
	import { conditionsFunc } from 'src/helpers/utilities';
	import CustomDynamicInput from 'src/components/CustomDynamicInput.svelte';

	export let input_val: string | number = 0;

	$: msg = $format('condition_timer', { values: { n: Number(input_val) } });

	let handle_input = (e) => {
		input_val = +e.target.value;
	};

	$: error = conditionsFunc(input_val as string, true)
		? $format('value_must_be_greater_than_zero', {
				default: 'Value must be an integer and greater than 0.',
			})
		: undefined;

	let onIncrement = () => {
		if (!error) {
			input_val = +input_val + 1;
		} else {
			input_val = 1;
		}
	};

	let onDecrement = () => {
		if (!error && +input_val > 1) {
			input_val = +input_val - 1;
		} else {
			input_val = 1;
		}
	};
</script>

<Text styleType="h2" class="mb-s">{msg}</Text>

<CustomDynamicInput
	additionalInputAttributes={{
		min: 1,
		icon: 'fas fa-clock',
	}}
	disabledMinusBtn={+input_val <= 1}
	bind:value={input_val}
	bind:error
	bind:inputHandler={handle_input}
	bind:minusFunction={onDecrement}
	bind:plusFunction={onIncrement}
/>
